<template>
  <ClassesList />
</template>

<script>
import ClassesList from '@/components/content/classes/AllClasses.vue'

export default {
  name: 'ContentClasses',
  components: { ClassesList }
}
</script>

<style scoped>

</style>
